import Icon from '../../Icon';

export const CollectionInfoTab = ({ active, onClick, icon, title }) => {
  return (
    <div
      className={`
        ${
          active
            ? 'bg-accent-dark text-white dark:bg-accent'
            : 'bg-white text-jacarta-700 hover:bg-[#E7E8EC] dark:bg-jacarta-800 dark:hover:bg-jacarta-600'
        }
          rounded-xl mb-2 inline-flex w-fit cursor-pointer items-center justify-center
          gap-1 border border-[#E7E8EC] px-4 py-2 transition-colors
          duration-300 ease-in-out dark:border-jacarta-600 dark:text-jacarta-100
        `}
      onClick={onClick}
    >
      {icon && <Icon name={icon} className='h-5 w-5' />}
      <div className='flex flex-nowrap items-center'>{title}</div>
    </div>
  );
};

export const CollectionInfoTabPanel = ({ children, value, index }) => {
  return <>{value === index && children}</>;
};
